
import { TableModule } from 'src/app/table/table.module';
import { TableModel } from 'src/models/table.model';

declare global {
    interface String {
        toAddPrefix(prefix: string): string;
    }
    interface Array<T> {
        isValid(): boolean;
        // map(T, value: boolean): Array<T>;
    }
    interface Array<T> {
        maper<T>(TModel: T): Array<T>;
    }
    interface Map<K, V> {
        SetInArray<V>(this: Map<K, V[]>, key: K, value: V): boolean;
    }
}
String.prototype.toAddPrefix = function (prefixStr: string) {
    return `${prefixStr}${this}`;
};
Array.prototype.isValid = function (): boolean {
    if (!(this) || this.length <= 0) {
        return false;
    }
    return true;
};
Array.prototype.maper = function maper<T>(destination_model: T): Array<T> {
    const arr = [];
    // //var destination_model = new T();
    const destination = Object.keys(destination_model);
    const source = Object.keys(this[0]);
    this.forEach(item => {
        const obj = JSON.parse(JSON.stringify(destination_model));
        source.forEach(key => {
            if (destination.some(el => el === key)) {
                obj[key] = item[key];
            }
        });
        arr.push(obj);
    });
    return arr;
};
Map.prototype.SetInArray = function <K, V>(this: Map<K, V[]>, key: K, value: V): boolean {
    let isNew = false;
    if (this.has(key) === false) {
        this.set(key, []);
        isNew = true;
    }
    const items: V[] = this.get(key)!;
    items.push(value);
    return isNew;
};

export { };
